import { css } from 'styled-components';
import { mediaq } from '~/themes/style-utils-v2';
const styles = css `
  max-height: ${(props) => props.maxHeight}px;
  max-width: ${(props) => props.maxWidth}px;
  ${mediaq.sm `
  max-height: ${(props) => props.maxHeight / (props.smallerOnMobile ? 2 : 1)}px;
  max-width: ${(props) => props.maxWidth / (props.smallerOnMobile ? 2 : 1)}px;
  `}
`;
export default styles;
